import React, { useState } from "react";
import AddHonorModal from "../modals/AddHonorModal";
import {
  honor_1,
  honor_2,
  honor_3,
  honor_4,
  honor_5,
  honor_6,
} from "../../../constants/icons";

const HonorsSection = ({ isEditing, honors = [], onUpdateHonors }) => {
  const [showHonorModal, setShowHonorModal] = useState(false);

  const handleAddHonor = (honorData) => {
    const newHonor = {
      id: Date.now(),
      ...honorData,
    };
    onUpdateHonors([...honors, newHonor]);
    setShowHonorModal(false);
  };

  const handleRemoveHonor = (honorId) => {
    const updatedHonors = honors.filter((honor) => honor.id !== honorId);
    onUpdateHonors(updatedHonors);
  };

  const getBackgroundStyle = (index) => {
    const backgrounds = [
      "linear-gradient(180deg, #FCF7FF 0%, #F7E9FF 100%)",
      "linear-gradient(180deg, rgba(231, 247, 255, 0.4) 0%, rgba(169, 225, 255, 0.4) 100%)",
      "linear-gradient(180deg, rgba(255, 221, 221, 0.4) 0%, rgba(255, 177, 177, 0.4) 100%)",
      "linear-gradient(180deg, #FFDBEB 0%, #FFD8EA 100%)",
      "linear-gradient(180deg, rgba(255, 240, 213, 0.4) 0%, rgba(255, 208, 130, 0.4) 100%)",
      "linear-gradient(180deg, #F8FFF7 0%, #E2FFE8 100%)",
    ];
    return backgrounds[index % backgrounds.length];
  };

  const getBorderStyle = (index) => {
    const borders = [
      "border-[#E7BCFF]",
      "border-[#9FDDFF]",
      "border-[#FFC2C2]",
      "border-[#FD89CB]",
      "border-[#FFD082]",
      "border-[#7FFE9B]",
    ];
    return borders[index % borders.length];
  };

  const getHonorIcon = (index) => {
    const icons = [honor_1, honor_2, honor_3, honor_4, honor_5, honor_6];
    return icons[index % icons.length];
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">HONOR & AWARDS</h2>
        {isEditing && (
          <button
            onClick={() => setShowHonorModal(true)}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add
          </button>
        )}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {honors.length === 0 && (
          <div className="col-span-full text-sm text-gray-500 text-center py-8">
            No honors & awards added yet.
          </div>
        )}

        {honors.map((honor, index) => (
          <div
            key={honor.id}
            className={`rounded-xl p-4 gap-4 flex items-center text-center relative border ${getBorderStyle(
              index
            )}`}
            style={{ background: getBackgroundStyle(index) }}
          >
            <div className="">
              <img
                src={getHonorIcon(index)}
                alt="Honor Icon"
                className="w-16 h-16"
              />
            </div>

            <div>
              <div className="text-[#222A35] text-[16px] font-bold ">
                {honor.title}
              </div>
              <div className="text-[#646B7E] text-[14px]">{honor.year}</div>
            </div>

            {isEditing && (
              <button
                onClick={() => handleRemoveHonor(honor.id)}
                className="absolute top-2 right-2 w-6 h-6 bg-[#FF4D4F1A] border border-[#FF4D4F] rounded-full flex items-center justify-center"
              >
                <span className="text-[#FF4D4F] text-xs font-bold">×</span>
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Honor Modal */}
      {showHonorModal && (
        <AddHonorModal
          onClose={() => setShowHonorModal(false)}
          onAdd={handleAddHonor}
        />
      )}
    </div>
  );
};

export default HonorsSection;
